import introTextMockJson from '../../../modules/_localDevMocks/IntroTextMock.json';
import { IntroTextModelProps } from '../IntroText.types';

export const introTextMockData = introTextMockJson as IntroTextModelProps;
